import Api from '../shared/api';
import Http from '../shared/http';

import { FaqModel } from '../shared/models';

export default class FaqController extends Api {

  public static get(id: string): Promise<FaqModel | undefined> {
    return Http.get('faq/' + id).then((result: FaqModel | undefined) => {
      if (result === undefined) {
        return Promise.resolve(undefined);
      }
      else {
        return Promise.resolve(result);
      }
    });
  }

  public static list(): Promise<FaqModel[]> {
    return Http.get('faq/list').then((result: FaqModel[]) => {
      if (result === undefined) {
        return Promise.resolve([]);
      }
      else {
        result = result.sort((n1,n2) => {
          if (n1.SortOrder > n2.SortOrder) {
            return 1;
          }
          if (n1.SortOrder < n2.SortOrder) {
            return -1;
          }
          return 0;
        });
        return Promise.resolve(result);
      }
    });
  }
  
  public static update(item: FaqModel) {
    return Http.post('faq/update', item).then((result: string) => {
      return Promise.resolve(result);
    });
  }

}